import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "../../../store/actions";
import { isEmpty } from 'lodash';
import { i18n } from '../../../translate/i18n';
import {
  Container, Paper, Typography, FormControl, FormLabel, IconButton, TextField, FormControlLabel, RadioGroup, Radio, Avatar, Divider,
  Switch,
  FormHelperText,
} from '@mui/material';

import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from './styles';

import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';

import confirm from '../../../UI/Confirm/confirm';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import Spinner from '../../../components/Spinner/index';
import { EAccessRole } from '../../../store/types';

const FormParamUsers = (props) => {
  const dispatch = useDispatch();

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("")
  const [profile, setProfile] = useState([])
  const [role, setRole] = useState("analyst");

  const [accessId, setAccessId] = useState("");

	const [searchTextSites, setSearchTextSites] = useState("")
  const [selectedSites, setSelectedSites] = useState([]);
  const [sitesFormated, setSitesFormated] = useState([])

  const [searchTextCompanies, setSearchTextCompanies] = useState("")
  const [companiesFormated, setCompaniesFormated] = useState([])
  const [selectedCompanies, setSelectedCompanies] = useState(null);

  const [inspector, setInspector] = useState(false);

  const [nameError, setNameError] = useState(false);
  const [profileError, setProfileError] = useState(false);
  const [sitesError, setSitesError] = useState(false);
  const [companiesError, setCompaniesError] = useState(false);


  const fetchUserById = useCallback(
    () => dispatch(actions.fetchUserById(props.match.params.id))
  );

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSites(1, 30, searchTextSites, order, orderBy)),
    [searchTextSites, order, orderBy]
  );
	const fetchCompanies = useCallback(
    () => dispatch(actions.fetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
    [page, limit, searchTextCompanies, order, orderBy]
  );


  const user = useSelector(state => state.users.user);
  const sites = useSelector(state => state.sites.sites);
  const companies = useSelector(state => state.companies.companies);

  const loadingUser = useSelector(state => state.users.loading);
  const loadingSites = useSelector(state => state.sites.loading);
  const loadingCompanies = useSelector(state => state.companies.loading);

  const isContractor = role === EAccessRole.contractor;
  const isAnalyst = role === EAccessRole.analyst;

  //check if is newEntrance or editing
  useEffect(() => {
    fetchUserById()
  }, [])

  useEffect(() => {
    if (!isEmpty(user)) {
      setName(user.name)
      setEmail(user.email)
      setProfile([user.photo])

      const access = user.access;

      if (access.length >= 1) {
        setAccessId(access[0]._id);
        let sites = []
        access[0].sites && access[0].sites.map(site => sites.push({ value: site._id, label: site.name }))
        setSelectedSites(sites)
        setRole(access[0].role)
        setInspector(access[0].inspector || false)

        if (access[0].company) {
          setSelectedCompanies({ value: access[0].company._id, label: access[0].company.name })
        }
      }

    }
  }, [user])

	// Autocomplete Sites
  useEffect(() => {
    const dataFromRedux = sites
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setSitesFormated(returnArray)
  }, [sites])

	useEffect(() => {
    fetchSites(searchTextSites, order, orderBy);
  }, [searchTextSites]);

	// Autocomplete Companies
	useEffect(() => {
    const dataFromRedux = companies
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setCompaniesFormated(returnArray)
  }, [companies])

  useEffect(() => {
    fetchCompanies(page, limit, searchTextCompanies, order, orderBy);
  }, [searchTextCompanies]);

  //send data to Server (post and update)
  const updateUsers = (body) => dispatch(actions.updateUsers(props.match.params.id, body))
  const updateUserAccess = (body) => dispatch(actions.updateUserAccess(props.match.params.id, accessId, body))
  const deleteUsers = () => dispatch(actions.deleteUsers(props.match.params.id,page,limit,'',order,orderBy ))

  const handleBack = () => {
    props.history.goBack()
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!name) {
      setNameError(true);
      hasError = true
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }

    if (isContractor) {
      if (!selectedCompanies || !selectedCompanies.value) {
        setCompaniesError(true)
        hasError = true;
      }
    }

    if (hasError) return

    let sitesIds = [];

    if (selectedSites && selectedSites.length > 0) {
      selectedSites.map(site => sitesIds.push(site.value));
    }

    let body = {}

    if (isNewData) {
      body = {};

      if (profile.length > 0 && profile[0] && (profile[0].id || profile[0]._id)) {
        body["photo"] = profile[0].id ? profile[0].id : profile[0]._id
      }
    } else {
      body = {
        role,
        sites: sitesIds,
				company: selectedCompanies?.value,
        inspector,
      }
    }

    updateUserAccess(body).then(result => {
      if (result === 'success') {
        setEditMode(false)
      }
    })
  }

  const handleInputChangeSelectorSites = (text) => {
    setSearchTextSites(text);
  }
  const handleInputChangeSites = selected => {
    setSitesError(false);
    setSelectedSites(selected)
  }

  const handleInputChangeSelectorCompanies = (text) => {
    setSearchTextCompanies(text);
  }
  const handleInputChangeCompanies = selected => {
    setCompaniesError(false);
    setSelectedCompanies(selected)
  }

  const handleClose = () => {
    // verifica se algo foi alterado
    if (false) {
      confirm(i18n.t('handleCloseFormParamUser.confirm'),
        {
          title: i18n.t('handleCloseFormParamUser.title'),
          titleColor: 'red',
          disableBackdrop: true
        })
        .then(
          () => {
          },
          async () => {
            // handleCloseRestoreDefault();
            setEditMode(false)
          },
        )
    } else {
      setEditMode(false)
    }
  }

  const handleDeleteUser = () => {
    confirm(i18n.t('handleDeleteUserFormParamUser.confirm'),
      {
        title: i18n.t('handleDeleteUserFormParamUser.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteUser()
        },
      )
  }

  const deleteUser = () => {
    deleteUsers().then(result => {
      console.log('RESULT', result)
      if (result === 'success') {
        props.history.goBack()
      }
    })
  }

  return <>
    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <Container maxWidth='sm'>
      <Paper style={{ position: 'relative' }}>
        {loadingUser && <Spinner overlay />}
        <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingUser ? '0.3' : '1' }}>
          <DivFormTitle>
            <Typography variant='h6'>{i18n.t('typographyFormParamUser.text')}</Typography>
            {!isNewData &&
              <DivSubmitButtons>
                {editMode ?
                  <>
                    <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                    <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                  </> :
                  <>
                    <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                    <IconButton onClick={() => handleDeleteUser()} size="large"><DeleteIcon /></IconButton>
                  </>
                }
              </DivSubmitButtons>
            }
          </DivFormTitle>
          <Divider />
          <>
            <div style={styles.imageInput}>
                {!isNewData && profile && !profile[0] ?
                <Avatar style={styles.avatar}>FOTO</Avatar>
                : (<>
                  <Avatar src={profile && profile[0] && profile[0].url} style={styles.avatar}></Avatar>
                </>)}
            </div>

            <FormControl variant="standard" fullWidth margin='normal' required>
              <TextField
                variant="standard"
                required
                label={i18n.t('textFieldFormParamUser.name')}
                name='name'
                onChange={event => setName(event.target.value)}
                value={name}
                disabled={true}
                margin='normal' />
            </FormControl>

            <FormControl variant="standard" fullWidth margin='normal' required>
              <TextField
                variant="standard"
                required
                label={i18n.t('textFieldFormParamUser.email')}
                name='email'
                onChange={event => setEmail(event.target.value.toLowerCase())}
                value={email}
                disabled={true}
                margin='normal' />
            </FormControl>

            <FormControl variant="standard" fullWidth margin='normal'>
              <Autocomplete
                isMulti
                loading={loadingSites} //sent to isLoading
                label={i18n.t('autocompleteFormParamUser.sites')}
                data={sitesFormated} // sent to options
                onSelectValue={handleInputChangeSites} // sent to onChange
                valueSelected={selectedSites} // sent to value
                newSearchText={handleInputChangeSelectorSites}
                name='site'
                hasError={sitesError}
                disabled={!isNewData && !editMode}
              />
            </FormControl>

            <FormControl variant="standard" component="fieldset" margin='normal'>
              <FormLabel component="legend">{i18n.t('formLabelFormParamUser.text')}</FormLabel>
              <RadioGroup
                aria-label="gender"
                name="role"
                value={role}
                onChange={event => {
                  setRole(event.target.value);
                }}
                margin='normal'
                disabled={!isNewData && !editMode}
              >
                <FormControlLabel value="admin" control={<Radio disabled={!isNewData && !editMode} />} label={i18n.t('formControlLabelFormParamUser.admin')} />
                <FormControlLabel value="analyst" control={<Radio disabled={!isNewData && !editMode} />} label={i18n.t('formControlLabelFormParamUser.analyst')} />
                <FormControlLabel value="contractor" control={<Radio disabled={!isNewData && !editMode} />} label={i18n.t('formControlLabelFormParamUser.contractor')} />
              </RadioGroup>
            </FormControl>

            {isContractor &&
              <FormControl
                variant="standard"
                fullWidth
                margin='normal'
                style={{ marginBottom: '2rem' }}>
                  <Autocomplete
                    loading={loadingCompanies} //sent to isLoading
                    label={i18n.t('autocompleteFormParamUser.companies')}
                    data={companiesFormated} // sent to options
                    onSelectValue={handleInputChangeCompanies} // sent to onChange
                    valueSelected={selectedCompanies} // sent to value
                    newSearchText={handleInputChangeSelectorCompanies}
                    name='companies'
                    hasError={companiesError}
                    disabled={!isNewData && !editMode}
                  />
              </FormControl>
            }

            { (isContractor || isAnalyst) &&
              <FormControl fullWidth margin='normal'>
                <FormControlLabel
                  control={<Switch checked={inspector} onChange={e => setInspector(e.target.checked)} disabled={!isNewData && !editMode}/> }
                  label={i18n.t('typographyFormParamUser.inspector')}
                />
                <FormHelperText sx={{margin: 0}}>{i18n.t('typographyFormParamUser.inspectorHelperText')}</FormHelperText>
              </FormControl>
            }

          </>
        </FormStyled>
      </Paper>
    </Container>
  </>;
}

export default FormParamUsers;

const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  buttonEditImage: {
    // margin: '-58px 0 0 -146px',
    margin: '10px 0',
  }
}
